module.exports = __webpack_public_path__ + "static/media/planing-no-data.db9073ca.png";